import { transformImage } from '@/helpers/transforms'
import type { TextWithImageAsideBlock } from '@/payload-types'
import type { SerializedBlockNode } from '@payloadcms/richtext-lexical'
import type { JSXConverter } from '@payloadcms/richtext-lexical/react'
import { CMSBlocks } from '../atoms/CMSBlocks'
import { ImageWithCorner } from '../atoms/ImageWithCorner'
import { ColumnsBlock } from '../blocks/ColumnsBlock'

export const TextWithImageAsideConverter: JSXConverter<
	SerializedBlockNode<TextWithImageAsideBlock>
> = ({ node, nodesToJSX }) => {
	const { content, image, imageCaption, layout } = node.fields

	const columnLayout = layout === 'image-on-right' ? 'default' : 'reverse'

	const imageData = transformImage(image)

	const richTextContent = (
		<CMSBlocks>{nodesToJSX({ nodes: content?.root?.children ?? [] })}</CMSBlocks>
	)

	return (
		<ColumnsBlock columnLeft={richTextContent} columnLayout={columnLayout}>
			<ImageWithCorner image={imageData} aspectRatio="aspect-none" />
			{imageCaption && (
				<span className="mt-sm block text-body-xs text-blue-shade-70">{imageCaption}</span>
			)}
		</ColumnsBlock>
	)
}
